import { useMutation } from 'react-query';
import { IconName } from '@wegroup/design-system';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface InsuranceTermsBotChatResponse {
  id: string;
  message: string;
  company: string;
  subject: string;
  created_at: string;
  resources?: InsuranceTermsBotResource[];
}

export interface InsuranceTermsBotResourceSection {
  title: string;
  reference: string;
  page: number;
}

export interface InsuranceTermsBotResource {
  created_at: string;
  filename: string;
  language: string;
  link: string;
  name: string;
  type: string;
  icon_key: IconName;
  section: InsuranceTermsBotResourceSection;
}

interface Params {
  insuranceCompany: string;
  insuranceSubject: string;
  message: string;
}

const postInsuranceTermsBotChat = async (payload: Params) => {
  const { data, isError } = await wgApi.post<InsuranceTermsBotChatResponse>(
    `/v1/api/insurance-terms-bot/chat`,
    {
      message: payload.message,
      insurance_company: payload.insuranceCompany,
      insurance_subject: payload.insuranceSubject,
    },
  );
  if (isError) throw new Error();
  return data;
};

export const usePostInsuranceTermsBotChat = () => {
  return useMutation(postInsuranceTermsBotChat);
};
